module.exports = __webpack_public_path__ + "img/bg.a6c7f8fc.jpg";